// import React from 'react'
// import { useSelector } from "react-redux";
// import './topbar.css'
// import bell from './notification.png'
// import surveyorIcon from './surveyorIcon.png';
// import dp from './dp.png'

// const Topbar = (props) => {
//   const { user } = useSelector(state => state.appStore)
//   const userType = useSelector((state) => state.appStore?.user?.userType);
//   console.log("12-topbar", userType);
//   return (
//     <div className="topbar-container">
//       <div className="topbar">
//         <span className="logo-container">
//           <img src={surveyorIcon} alt="Surveyor's AI" className="surveyor-icon" />
//         </span>
//         <div className="user-info">
//           <span>
//             <img src={bell} alt="bell" className="bell" />
//           </span>
//           <span>
//             <img src={dp} alt="dp" className="dp" />
//           </span>
//         </div>
//       </div>
//       <div className='topbar-children'>{props.children}</div>
//     </div>
//   )
// }

// export default Topbar
//2
// import React, { useEffect, useState } from 'react';
// import { useSelector } from "react-redux";
// import axios from "axios";
// import './topbar.css';
// import bell from './notification.png';
// import surveyorIcon from './surveyorIcon.png';
// import defaultDp from './dp.png'; // Default dp icon

// const Topbar = (props) => {
//   const { user } = useSelector(state => state.appStore);
//   const userType = user?.userType;
//   const [logoUrl, setLogoUrl] = useState(null);

//   useEffect(() => {
//     const fetchLogoFromAzure = async (organizationId, organizationName) => {
//       try {
//         const fileName = `${organizationId}-${organizationName}.jpeg`;
//         const baseUrl = 'https://caisdatahouse.blob.core.windows.net/insurance-inspection/organization-logos';
//         const sasToken = 'sv=2022-11-02&ss=b&srt=sco&sp=rwdlacyx&se=2030-12-24T21:24:33Z&st=2023-12-24T13:24:33Z&spr=https&sig=Ytog9LRRNwVpscHMH5q3Q8F7v6U2Te5F6oU8%2F1WArio%3D';
//         const logoUrl = `${baseUrl}/${fileName}?${sasToken}`;

//         const response = await axios.get(logoUrl, { responseType: 'blob' });
//         if (response.status === 200) {
//           const fetchedLogo = URL.createObjectURL(response.data);
//           return fetchedLogo;
//         }
//       } catch (error) {
//         console.error('Error fetching logo:', error);
//         return null;
//       }
//     };

//     if (userType === "org_admin" && user?.org_id && user?.org_name) {
//       fetchLogoFromAzure(user.org_id, user.org_name).then(setLogoUrl);
//     }
//   }, [userType, user?.org_id, user?.org_name]);

//   return (
//     <div className="topbar-container">
//       <div className="topbar">
//         <span className="logo-container">
//           <img src={surveyorIcon} alt="Surveyor's AI" className="surveyor-icon" />
//         </span>
//         <div className="user-info">
//           <span>
//             <img src={bell} alt="Notifications" className="bell" />
//           </span>
//           <span>
//             <img 
//               src={userType === "org_admin" && logoUrl ? logoUrl : defaultDp} 
//               alt="User" 
//               className="dp" 
//             />
//           </span>
//         </div>
//       </div>
//       <div className='topbar-children'>{props.children}</div>
//     </div>
//   );
// };

// export default Topbar;

import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import axios from "axios";
import "./topbar.css";
import bell from "./notification.png";
import surveyorIcon from "./surveyorIcon.png";
import defaultDp from "./AndroidApp.png"; // Default dp icon
import NotificationPanel from "./NotificationPanel"; // Import the panel

const Topbar = (props) => {
  const { user } = useSelector((state) => state.appStore);
  const userType = user?.userType;
  const [logoUrl, setLogoUrl] = useState(null);
  const [isNotificationOpen, setIsNotificationOpen] = useState(false); // State to toggle panel

  useEffect(() => {
    const fetchLogo = async (organizationId, organizationName) => {
      const blobName = `Insurance_Inspection/organization-logos/${organizationId}-${organizationName}.jpeg`

      try {
        const response = await fetch('/auth/check_logo_exists', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ blobName })
        })

        const data = await response.json()
        console.log('Logo fetch response:', blobName, data)

        if (data.exists && data.url) {
          return data.url
        }
        return null
      } catch (error) {
        console.error('Error fetching logo signed URL:', error)
        return null
      }
    }
    if (userType === "org_admin" && user?.org_id && user?.org_name) {
      fetchLogo(user.org_id, user.org_name).then(setLogoUrl);
    }
  }, [userType, user?.org_id, user?.org_name]);

  return (
    <div className="topbar-container">
      <div className="topbar">
        <span className="logo-container">
          <img src={surveyorIcon} alt="Surveyor's AI" className="surveyor-icon" />
        </span>
        <div className="user-info">
          {/* Bell Icon to toggle notification panel */}
          {/* <span onClick={() => setIsNotificationOpen(!isNotificationOpen)}>
            <img src={bell} alt="Notifications" className="bell" />
          </span> */}
          <span>
            <img
              src={userType === "org_admin" && logoUrl ? defaultDp : defaultDp}
              alt="User"
              // className="dp"
              className={userType === "org_admin" && logoUrl ? "logoUrlDp" : "dp"}
            />
          </span>
        </div>
      </div>

      {/* Notification Panel */}
      <NotificationPanel
        isOpen={isNotificationOpen}
        onClose={() => setIsNotificationOpen(false)}
      />

      <div className="topbar-children">{props.children}</div>
    </div>
  );
};

export default Topbar;
